import { GroupSessionsForm } from '../components/form/GroupSessionsForm';

export const GroupSessionsCreateForm = GroupSessionsForm;
